export default __webpack_public_path__ + "static/media/romance1.efbf0ee9.jpg";